<template>
	<div class="font-bold">
		<div class="flex mb-4 -mx-1">
			<statistics-partials-plain
				class="mx-1 w-1/3 bg-forest-green text-white font-bold text-md p-2"
				:partial-title="`Par ${holePar} Average`"
				:partial-value="`${stats.totalScoring[`par_${holePar}_average`]} (${stats[`par${holePar}splayed`]} played)`"
			></statistics-partials-plain>
			<statistics-partials-plain
				class="mx-1 w-1/3 bg-forest-green text-white font-bold text-md p-2"
				:partial-title="`Par ${holePar} To Par`"
				:partial-value="`${stats.totalScoring[`par_${holePar}_to_par`]}`"
			></statistics-partials-plain>
		</div>

		<statistics-partials-plain
			v-if="holePar > 3"
			:partial-title="`Par ${holePar} Albatrosses`"
			:stats-graphic="{total: stats.totalScoring[`par_${holePar}_albatrosses`], outOf: stats[`par${holePar}splayed`]}"
			:partial-value="`${stats.totalScoring[`par_${holePar}_albatrosses`]}/${stats[`par${holePar}splayed`]}`"
		></statistics-partials-plain>
		<div class="flex mgs-stats-row">
			<statistics-partials-plain
				class="w-1/3 font-bold text-md"
				:partial-title="`Par ${holePar} Eagles`"
				:stats-graphic="{total: stats.totalScoring[`par_${holePar}_eagles`], outOf: stats[`par${holePar}splayed`]}"
				:partial-value="`${stats.totalScoring[`par_${holePar}_eagles`]}/${stats[`par${holePar}splayed`]}`"
			></statistics-partials-plain>
			<statistics-partials-plain
				class="w-1/3 font-bold text-md"
				:partial-title="`Par ${holePar} Birdies`"
				:stats-graphic="{total: stats.totalScoring[`par_${holePar}_birdies`], outOf: stats[`par${holePar}splayed`]}"
				:partial-value="`${stats.totalScoring[`par_${holePar}_birdies`]}/${stats[`par${holePar}splayed`]}`"
			></statistics-partials-plain>
			<statistics-partials-plain
				class="w-1/3 font-bold text-md"
				:partial-title="`Par ${holePar} Pars`"
				:stats-graphic="{total: stats.totalScoring[`par_${holePar}_pars`], outOf: stats[`par${holePar}splayed`]}"
				:partial-value="`${stats.totalScoring[`par_${holePar}_pars`]}/${stats[`par${holePar}splayed`]}`"
			></statistics-partials-plain>
		</div>
		<div class="flex mgs-stats-row">
			<statistics-partials-plain
			class="w-1/3 font-bold text-md"
				:partial-title="`Par ${holePar} Bogeys`"
				:stats-graphic="{total: stats.totalScoring[`par_${holePar}_bogeys`], outOf: stats[`par${holePar}splayed`]}"
				:partial-value="`${stats.totalScoring[`par_${holePar}_bogeys`]}/${stats[`par${holePar}splayed`]}`"
			></statistics-partials-plain>
			<statistics-partials-plain
			class="w-1/3 font-bold text-md"
				:partial-title="`Par ${holePar} Double Bogeys`"
				:stats-graphic="{total: stats.totalScoring[`par_${holePar}_double_bogeys`], outOf: stats[`par${holePar}splayed`]}"
				:partial-value="`${stats.totalScoring[`par_${holePar}_double_bogeys`]}/${stats[`par${holePar}splayed`]}`"
			></statistics-partials-plain>
			<statistics-partials-plain
			class="w-1/3 font-bold text-md"
				:partial-title="`Par ${holePar} Triple+`"
				:stats-graphic="{total: stats.totalScoring[`par_${holePar}_triple_or_worse`], outOf: stats[`par${holePar}splayed`]}"
				:partial-value="`${stats.totalScoring[`par_${holePar}_triple_or_worse`]}/${stats[`par${holePar}splayed`]}`"
			></statistics-partials-plain>

		</div>
		<statistics-partials-plain
				:partial-title="`Par ${holePar} Penalties`"
				:partial-value="`${stats.totalScoring[`par_${holePar}_penalties`]}`"
			></statistics-partials-plain>
	</div>
</template>
<script>
/** @format */

export default {
	name: 'StatisticsByPar',
	props: {
		holePar: {
			type: Number | String,
			required: true
		},
		stats: {
			type: Object,
			required: true
		}
	},
	components: {
		'statistics-partials-plain': () => import(/* webpackChunkName: "StatisticsPlain" */ './Partials/Plain')
	}
};
</script>

<style lang="scss">
.mgs-stats-row {
	@apply -mx-1;
	.mgs-plain-statbox {
		@apply mx-1;
	}
}
</style>
